/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Plansuffix1Inputs */

const zh_subscription_plansuffix1 = /** @type {(inputs: Subscription_Plansuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计划`)
};

const en_subscription_plansuffix1 = /** @type {(inputs: Subscription_Plansuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const es_subscription_plansuffix1 = /** @type {(inputs: Subscription_Plansuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Subscription_Plansuffix1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_plansuffix1 = /** @type {((inputs?: Subscription_Plansuffix1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Plansuffix1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_plansuffix1(inputs)
	if (locale === "en") return en_subscription_plansuffix1(inputs)
	return es_subscription_plansuffix1(inputs)
});
export { subscription_plansuffix1 as "subscription_planSuffix" }